import * as React from 'react';
import { IconChevronRight16 } from '@cian/ui-kit/icons';
import * as styles from './GradientArrowRight.css';
import { GRADIENT_ARROW_WIDTH } from '../../constants/arrows';

interface IGradientArrowRightProps {
  onClick(): void;
}

export const GradientArrowRight: React.FC<IGradientArrowRightProps> = ({ onClick }) => {
  return (
    <div style={{ width: `${GRADIENT_ARROW_WIDTH}px` }} className={styles['arrow']} onClick={onClick}>
      <IconChevronRight16 color="gray_icons_100" />
    </div>
  );
};
